
export function Button({ children, type = "button", disabled = false, ...props }) {
    return (
        <button
            type={type}
            className={`w-full p-2 rounded-md transition-colors ${disabled 
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
                : 'bg-blue-500 text-white hover:bg-blue-600'}`}
            disabled={disabled}
            {...props}
        >
            {children}
        </button>
    )
}

//nuevo w-full bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600

//viejo flex w-full justify-center rounded-md bg-cyan-500  dark:bg-cyan-700 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600